<template>
    <div class="relative flex flex-col h-screen">
        <img :src="getImage('mascot')" class="fixed papsi-mascot">

        <div class="flex flex-1 lg:flex-row flex-col">
            <SidebarSection>
                <LabelControl type="message" :content="$t('has008')" />
                <!-- <div class="bg-white rounded-xl p-8 relative">
                    <p class="text-grey-darker text-4xl font-medium">Please read our contact information</p>                 
                    <div class="bubble-pointer"></div>
                </div> -->
            </SidebarSection>

            <ContentSection @logout="logout">
                <div class="bg-grey-lighter p-10 rounded-lg overflow-hidden papsi-container">
                    <LabelControl class="mb-10" type="heading" :content="$t('has005')" />

                    <div class="flex flex-row items-center">
                        <img :src="getImage('kalabaw')" style="width: 30rem; height: 30rem;" class="papsi-kara" />
                        <div class="flex flex-col w-full">
                            <div
                                class="bg-white flex flex-col align-center justify-center items-start rounded-xl p-8 w-full mb-5">
                                <h3 class="text-3xl mb-3 text-grey-darker">{{ $t('has009') }}</h3>
                                <p class="text-3xl text-grey-darker">Monday to Friday <br>9:00 AM to 4:00 PM (Except
                                    Holidays)</p>
                            </div>

                            <div
                                class="bg-white flex flex-col align-center justify-center items-start rounded-xl p-8 w-full mb-5">
                                <h3 class="text-3xl mb-3 text-grey-darker">{{ $t('mip006') }}</h3>
                                <p class="text-3xl text-grey-darker">customer@pafcpic365.com</p>
                            </div>

                            <div
                                class="bg-white flex flex-col align-center justify-center items-start rounded-xl p-8 w-full mb-5">
                                <h3 class="text-3xl mb-3 text-grey-darker">{{ $t('mip005') }}</h3>
                                <p class="text-3xl mb-1 text-grey-darker">(+63) 998-588-1969</p>
                            </div>
                        </div>
                    </div>


                </div>

            </ContentSection>
        </div>

        <FooterSection />
    </div>
</template>

<script>
import SidebarSection from '@/components/sections/SidebarSection.vue';
import ContentSection from '@/components/sections/ContentSection.vue';
import FooterSection from '@/components/sections/FooterSection.vue';
import mixin from '@/mixins/controls.js';
import LabelControl from '@/components/controls/LabelControl.vue';

export default {
    mixins: [mixin],
    components: {
        SidebarSection,
        ContentSection,
        FooterSection,
        LabelControl,
    },
    mounted() {
        this.$emit('checkauth');
    },
    methods: {
        logout() {
            this.$emit('logout');
        },
    },
};
</script>

<style scoped>
.papsi-mascot {
    bottom: 0;
    left: 0;
    width: 25rem;
}

.papsi-container {
    height: 45rem;
}

.papsi-text {
    height: 34rem;
}

.papsi-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 3rem;
}

.bubble-pointer {
  position: absolute;
  left: 20%;
  bottom: -15px; /* Adjust based on your needs */
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-top: 16px solid white;
}

@media (min-width: 2500px) {
  .papsi-kara {
    height: 35rem !important;
    width: 35rem !important;
  }

  .papsi-container {
    height: 53rem !important;
}
}
</style>
